<script>
  import { onMount } from "svelte";
  import Marquee from 'svelte-fast-marquee';

  import Message from "../Message.svelte";
  import Loading from "../Loading.svelte";
  import Clock from "../Clock.svelte";

  import { parseMode } from "../helpers";
  import { replaceStopName } from "../helpers";
  import { tooltip } from '../utils';
  import { getLocalStorage } from '../utils';
  import { VERSION } from "../version"

  export let groupId;
  export let limit;
  export let type;
  export let systemUrl;
  export let displayMode;
  export let showLogo;

  let hashHeader = getLocalStorage('instanceId')
  localStorage.setItem('board-version', VERSION)

  let currentYear = new Date().getFullYear();
  let data = {};
  let groupName = ''

  let show_clock = true;
  let show_date = true;

  let delay_minutes = type == 'departures' ? 0 : 3;
  let delay_ms = delay_minutes * -1 * 60 * 1000;

  let request_type = (type == 'departures' || type == 'arrivals') ? type : 'departures';
  let request_type_trans =  type == 'departures' ? 'partidas' : 'chegadas';

  let inactive_group = false;
  let lines_per_page = 5;
  let line_count = 0;
  let page_count = 0;
  let currentPage = 1;
  let line_start = 0;
  let line_end = lines_per_page;

  limit = isNaN(parseInt(limit)) ? 10 : parseInt(limit);
  let apiUrl = `https://${systemUrl}/v3/busdata/stop?group_id=${groupId}&type=${request_type}&delay_ms=${delay_ms}&limit=${limit}`
  let datetime;

  let currDate = 0;

  let destMaxChars = (window.innerWidth - 848) / 17; //848px is the total size of all other columns; 17 has an "educated guess" to the average width of a character
  //let destMaxChars = (window.innerWidth - 1020) / 17; //848px is the total size of all other columns; 17 has an "educated guess" to the average width of a character

  // Modal
  let modalTimeout = 120000;
  let hasFilter = false;
  let futureDate = false;
  let destinationStops = {}
  let destinationStopsFiltered = {}
  let filterReady = false;
  let isOpen = false;
  let date = "";
  let time = "";
  let destination = "";

  // timeouts
  let timeout;
  let requestTimeout;

  const keyboard = [
    ["1","2","3","4","5","6","7","8","9","0"],
    ["Q","W","E","R","T","Y","U","I","O","P"],
    ["A","S","D","F","G","H","J","K","L"],
    ["Z","X","C","V","B","N","M"]
  ]

  let typedText = "";

  const addLetter = (letter) => {
    typedText += letter;
    filterStops(typedText);
  };

  const backspace = () => {
    typedText = typedText.slice(0, -1);
    filterStops(typedText);
  };

  const clearText = () => {
    typedText = '';
    filterStops(typedText);
  };

  function filterStops(text){
    destinationStopsFiltered.stops = destinationStops.stops.filter((stop) => {
      const name = removeAccents(stop.stop_name_to_show ).toUpperCase();
      return name.toUpperCase().includes(text.toUpperCase())
    });

    destinationStopsFiltered.total = destinationStopsFiltered.stops.length;

    if(destination != undefined && destination != {} && destination != ''){
      let selected = destinationStopsFiltered.stops.find((stop) => stop.stop_name_to_show.includes(destination.stop_name_to_show.toUpperCase()))
      if(selected == undefined) destination = ''
    }
    if(destinationStopsFiltered.total == 1){
      destination = destinationStopsFiltered.stops[0]
    }
  }

  function removeAccents(str){
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  const timeOptions = Array.from({ length: 24 }, (_, i) => {
    const hour = String(i).padStart(2, '0');  // Adds leading zero for single-digit hours
    return `${hour}:00`;
  });

  $: filteredTimeOptions = (() => {
    if (!date) return timeOptions;

    const today = new Date();
    const selectedDate = new Date(date);

    if (
      selectedDate.getFullYear() === today.getFullYear() &&
      selectedDate.getMonth() === today.getMonth() &&
      selectedDate.getDate() === today.getDate()
    ) {
      const currentHour = today.getHours();
      // Filter future hours only
      return timeOptions.filter((t) => parseInt(t.split(':')[0]) > currentHour);
    }

    return timeOptions;
  })();

  const monthNames = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ];

  const dayOptions = Array.from({ length: 31 }, (_, i) => {
    const date = new Date();
    date.setDate(date.getDate() + i);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const value = `${year}-${month}-${day}`;
    const label = `${day} / ${monthNames[date.getMonth()]}`;

    return { value, label };
  });

  $: if (date) {
    const today = new Date();
    const selectedDate = new Date(date);
    if (
      selectedDate.getFullYear() === today.getFullYear() &&
      selectedDate.getMonth() === today.getMonth() &&
      selectedDate.getDate() === today.getDate()
    ) {
      const currentHour = today.getHours();
      if (time && parseInt(time.split(':')[0]) <= currentHour) {
        time = '';
      }
    }
  }

  function openModal() {
    isOpen = true;

    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      timeout = undefined;
      isOpen = false;
      clearText();
    }, modalTimeout);
  }

  function closeModal() {
    isOpen = false;
    clearText();

    if (timeout) {
      clearTimeout(timeout);
      timeout = undefined;
    }
  }

  function clearFromList() {
    event.preventDefault();
    date = "";
    time = "";
    destination = "";
    applyFilters();
  }

  function clear() {
    event.preventDefault();
    date = "";
    time = "";
    destination = "";
    clearText();
  }

  function applyFilters() {
    currentPage = 1;
    line_start = 0;
    line_end = lines_per_page;
    event.preventDefault();
    request();
    closeModal();
  }

  function toUTCISOStringFromTZ(dateStr, timeStr, timeZone) {
    const [year, month, day] = dateStr.split('-');
    const [hour, minute] = timeStr.split(':');

    // Create a date object in the given timeZone
    const local = new Date(Date.UTC(year, month - 1, day, hour, minute));

    // Use the timezone offset of the given zone
    const options = { timeZone, hour12: false };
    const utcOffsetDate = new Date(local.toLocaleString("en-US", { timeZone }));

    return utcOffsetDate.toISOString();
  }

  function toMillisInUTC(isoString) {
    // Parse UTC date
    const utcDate = new Date(isoString);

    // Format it in Portugal timezone and get a local Date
    const localStr = utcDate.toLocaleString("en-US", { timeZone: "UTC" });
    const localDate = new Date(localStr);

    return localDate.getTime();
  }

  const getDestinationStops = async () => {
    const res = await fetch(
      `https://${systemUrl}/v3/busdata/gtfs/stops`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'device-id': hashHeader,
          'board-version': VERSION
        },
        body: JSON.stringify({
          offset: 0,
          limit: 5000,
          include: true,
          origin_group_id: groupId,
          order_by: "stop_name",
          sort_by: "ASC"
        }),
      }
    );

    const resJson = await res.json();

    let results = [];

    if(resJson.total > 0){

      let parents = []
      resJson.results.map((d) => {

        if (d.parent_station != 'nan' && d.parent_station != null){
          
          if(!parents.includes(d.parent_station)){

            parents.push(d.parent_station)

            let stop = {
              stop_id: d.parent_station,
              stop_code: d.stop_code.slice(3),
              stop_name: d.stop_name.split(' - CAIS')[0],
              stop_name_to_show: d.stop_code.slice(3) != '' ? d.stop_name.split(' - CAIS')[0].toUpperCase() + '  - Nº ' + d.stop_code.slice(3) : d.stop_name.split(' - CAIS')[0].toUpperCase(),
              stop_municipality: d.municipality,
              trip_ids: d.trip_ids
            }

            results.push(stop)
          } else {
            const item = results.find(item => item.stop_id == d.parent_station);

            if (item) {
              item.trip_ids = item.trip_ids.concat(d.trip_ids);
            }
          }
        }

        results.push({
          stop_id: d.stop_id,
          stop_code: d.stop_code.slice(3),
          stop_name: d.stop_name,
          stop_name_to_show: d.stop_code.slice(3) != '' ? d.stop_name.toUpperCase() + '  - Nº ' + d.stop_code.slice(3) : d.stop_name.toUpperCase(),
          stop_municipality: d.municipality,
          trip_ids: d.trip_ids
        })
      })

      results.sort((a, b) => a.stop_name_to_show.localeCompare(b.stop_name_to_show));
    }


    destinationStops.total = results.length
    destinationStops.stops = results;

    destinationStopsFiltered.total = results.length
    destinationStopsFiltered.stops = results;

    filterReady = true;
  }

  function previousPage() {
    currentPage--;
    line_start -= lines_per_page;
    line_end -= lines_per_page;

    resetTimeout()

  }

  function nextPage() {
    currentPage++;
    line_start += lines_per_page;
    line_end += lines_per_page;

    resetTimeout()
  }

  function resetTimeout() {
    if (requestTimeout) {
      clearTimeout(requestTimeout);
    }

    requestTimeout = setTimeout(() =>
      {
        currentPage = 1;
        line_start = 0;
        line_end = lines_per_page;
        date = '';
        time = '';
        destination = '';
        request();
      }
      , 60000)
  }

  const request = async () => {

    if (requestTimeout) {
      clearTimeout(requestTimeout);
    }

    hasFilter = false;
    let apiUrlAux = ''

    if(destination != ''){
      destination.trip_ids.forEach(id => {
        apiUrlAux = apiUrlAux + `&trip_ids=${id}`
      })
      hasFilter = true;
    }

    if(date != '' && time != ''){
      datetime = toUTCISOStringFromTZ(date, time, "Europe/Lisbon");
      currDate = toMillisInUTC(datetime);

      if(currDate - new Date() > 0){
        apiUrlAux = apiUrlAux + `&date=${datetime}`
        hasFilter = true;
      }

    }

    inactive_group = false;
    const res = await fetch(
      apiUrl + apiUrlAux,
      {
        headers: {
            'device-id': hashHeader,
            'board-version': VERSION
        }
      }
    );

    const resJson = await res.json();

    if (res.status == 200) {
      
      let results = [];
      let index = 0;

      groupName = resJson.name;

      if(date == '' || time == ''){
        currDate = resJson.time_utc;
      }

      futureDate = (currDate - new Date()) > 60*60*1000

      line_count = resJson.services.length;

      page_count = Math.ceil(line_count / lines_per_page);

      resJson.services.map((d) => {

        let dest = ''

        switch (d.agency) {
          case "FLX":
            dest = d.next.destination.replace('FlixBus: ','')  + ' : destino ' + d.next.last_stop_name;
            break;
          case "RNE":
            dest = d.next.destination;
            break;
          default:
            dest = d.next.last_stop_name
        }

        let origin = d.agency == 'EXT' ? d.next.original_route_long_name :
          d.next.first_stop_name != undefined ? d.next.first_stop_name : dest;

        if (d.next != null) {
          results.push({
            id: d.no,
            stop_id: d.stop_id_filter.slice(3),
            stop_name: d.stop_name_filter,
            stop_code: d.stop_code_filter.slice(3),
            parent_stop_id: (d.parent_station_filter != '' && d.parent_station_filter != null) ? d.parent_station_filter.slice(3) : '',
            line: d.next.line,
            destination: replaceStopName(dest),
            destination_municipality: d.next.last_stop_municipality != null ? d.next.last_stop_municipality.toUpperCase() : "",
            origin: replaceStopName(origin),
            origin_municipality: d.next.first_stop_municipality!= null ? d.next.first_stop_municipality.toUpperCase() : "",
            platform: d.next.platform != null ? d.next.platform : "",
            arrivalTimeRelative: Math.max(0, Math.floor(d.next.arrival_ms / 1000 / 60)),
            arrivalTimeRelativeClock: new Intl.DateTimeFormat("pt", {
              hour: "numeric",
              minute: "numeric",
            }).format(new Date(currDate + d.next.arrival_ms)),
            arrivalDelayMs: d.next.arrival_delay_ms,
            arrivalTimeRelativeDelay: Math.max(0, Math.floor(d.next.arrival_delay_ms / 1000 / 60)),
            arrivalDelay: Math.floor((d.next.arrival_delay_ms - d.next.arrival_ms) / 1000 / 60),
            arrivalTimeRelativeDelayClock: new Intl.DateTimeFormat("pt", {
              hour: "numeric",
              minute: "numeric",
            }).format(new Date(currDate + d.next.arrival_delay_ms)),
            departureTimeRelative: Math.max(0, Math.floor(d.next.departure_ms / 1000 / 60)),
            departureTimeRelativeClock: new Intl.DateTimeFormat("pt", {
              hour: "numeric",
              minute: "numeric",
            }).format(new Date(currDate + d.next.departure_ms)),
            departureDelayMs: d.next.departure_delay_ms,
            departureTimeRelativeDelay: Math.max(0, Math.floor(d.next.departure_delay_ms / 1000 / 60)),
            departureDelay: Math.floor((d.next.departure_delay_ms - d.next.departure_ms) / 1000 / 60),
            departureTimeRelativeDelayClock: new Intl.DateTimeFormat("pt", {
              hour: "numeric",
              minute: "numeric",
            }).format(new Date(currDate + d.next.departure_delay_ms)),
            departureTimeRelative: Math.max(0, Math.floor(d.next.departure_ms / 1000 / 60)),
            agency: d.agency,
            mode: parseMode(d.agency,dest),
            nextLoad: d.next.load,
            stopSequence: d.next.stop_sequence,
            maxStopSequence: d.next.max_stop_sequence,
            index: index % 2,
            count: index
          });
          index++;
        }
      });

      data.name = resJson.name;
      data.departures = results;

      let timeoutMillis = hasFilter ? 120000 : 60000;
      //let timeoutMillis = (currentPage > 1 || hasFilter) ? 120000 : 60000;

      requestTimeout = setTimeout(() =>
        {
          date = '';
          time = '';
          destination = '';
          request();
        }
        , timeoutMillis)
    } else {
      inactive_group = true

      requestTimeout = setTimeout(() =>
        {
          date = '';
          time = '';
          destination = '';
          request();
        }
        , 600000)
    }

    
  };

  onMount(() => {

    if (hashHeader != null) {
      request(); // first request
      getDestinationStops();
    } else {
      setTimeout(() => { // wait for js has time to calculate hashHeader and set it on localStorage
        hashHeader = getLocalStorage('instanceId')
        if (hashHeader != null) {
          request(); // first request
          getDestinationStops();
        } else {
          setTimeout(() => { // wait again for js has time to calculate hashHeader and set it on localStorage
            hashHeader = getLocalStorage('instanceId')
            request()
            getDestinationStops();
          }, 3000);
        }
        request()
      }, 1000);
    }

    return () => {
      if (requestTimeout) {
        clearTimeout(requestTimeout);
      }
    };
  });
</script>

<div class="flex-1 w-1/2 font-gui" data-id={`group-${groupId}`}>
    {#if data}
      {#if data.name}
        <div>
          <div class="header-bg-{type} p-5">
            <div class="flex items-center justify-between">
              <div class="inline-flex">
                <img class="mr-10 ml-6 logo-system-gui" alt="Logo Cidade" src="img/logo-GUI-b.png">
                {#if type === 'departures'}
                  <h2 class="ml-10">PARTIDAS - {groupName}</h2>
                {:else}
                  <h2 class="ml-10">CHEGADAS - {groupName}</h2>
                {/if}
              </div>
              <div class="inline-flex items-center mr-6">
                {#if !displayMode && filterReady}
                  <button
                    on:click={openModal}
                    class:filter-wait={!hasFilter}
                    class:filter-active={hasFilter}
                    class="button-effect mr-16">
                    <div class="flex items-center">
                      <i class="fa-solid fa-filter"></i>
                      <span class="ml-10px">Filtros</span>
                    </div>
                  </button>
                {/if}

                <!--
                <div class="weather mr-16">
                  <Weather {lat} {lon}/>
                </div>
                -->
                <div class="block">
                  <div class="clock">
                    <Clock {show_clock}/>
                  </div>
                  <div class="date">
                    <Clock {show_date}/>
                  </div>
                </div>
              </div>
            </div>
            {#if destination.stop_name_to_show != undefined || date != '' || time != ''}
              <div class="flex justify-center items-center w-full pl-5">
                <div class="text-center my-auto date">
                  {#if destination.stop_name_to_show != undefined}
                    <div class="filters-font"> Horários com destino a {destination.stop_name_to_show}{#if date != '' && time != ''}, a partir das {time} de {date}{/if}<button on:click={clearFromList} class="button-trash ml-10px"><i class="fa-regular fa-trash-can"></i></button></div>
                  {:else}
                    {#if date != '' && time != ''}
                      <div class="filters-font">Horários a partir das {time} de {date}<button on:click={clearFromList} class="button-trash ml-10px"><i class="fa-regular fa-trash-can"></i></button></div>
                    {/if}
                  {/if}
                </div>
              </div>
            {/if}

          </div>
          <div class="flex flex-col w-full h-full whitespace-nowrap">
            <div class="flex flex-row h-16 bg-2 px-4 header-font">
              <div class="w-40 p-2 my-auto text-left" use:tooltip={VERSION}>Operador</div>
              <div class="w-28 my-auto text-left">Linha</div>
              {#if type === 'departures'}
                <div class="flex-grow my-auto text-left">Destino</div>
              {:else}
                <div class="flex-grow my-auto text-left">Origem</div>
              {/if}
              <div class="w-80 p-2 my-auto text-left">Município</div>
              {#if type === 'departures'}
                <div class="w-44 p-2 my-auto text-center">Partida</div>
              {:else}
                <div class="w-44 p-2 my-auto text-center">Chegada</div>
              {/if}
              <div class="w-80 p-2 my-auto text-center">Info</div>
            </div>
            {#each data.departures as {
              id,
              stop_name,
              stop_code,
              line,
              destination,
              destination_municipality,
              origin,
              origin_municipality,
              arrivalTimeRelative,
              arrivalTimeRelativeClock,
              arrivalDelayMs,
              arrivalTimeRelativeDelay,
              arrivalDelay,
              arrivalTimeRelativeDelayClock,
              departureTimeRelative,
              departureTimeRelativeClock,
              departureDelayMs,
              departureTimeRelativeDelay,
              departureDelay,
              departureTimeRelativeDelayClock,
              mode,
              stopSequence,
              maxStopSequence,
              index,
              count
            }}
            {#if count >= line_start && count < line_end}

              <div class="flex flex-row h-custom-group text-primary px-4 bg-{type}-{index}" data-id={id}>
                <div class="w-40 py-4 align-middle text-center flex-shrink-0 flex-grow-0">
                  <img class="h-full w-full" src={mode.iconUrl} alt={mode.name}/>
                </div>
                <!--<div class="w-40 my-auto color-white flex-shrink-0 flex-grow-0">
                  {mode.name}
                </div>-->
                <div class="w-28 text-left pr-2 my-auto font-bold color-white flex-shrink-0 flex-grow-0">
                  <span class="line"><strong>{line}</strong></span>
                </div>
                {#if type === 'departures'}
                  {#if destination.length > destMaxChars }
                  <div class="flex-grow text-left pr-2 my-auto color-white overflow-hidden">
                      <Marquee pauseOnHover={true} speed={destination.length * 0.3}>
                        <span class="color-white pr-10"><strong>{destination}</strong></span>
                      </Marquee>
                      Partida de <span class="badge header-bg-departures my-2"><strong>{stop_code}</strong>&nbsp;{stop_name}</span>
                  </div>
                  {:else}
                    <div class="flex-grow text-left pr-2 my-auto color-white overflow-hidden">
                      <strong>{destination}</strong>
                      <br>
                      Partida de <span class="badge header-bg-departures my-2"><strong>{stop_code}</strong>&nbsp;{stop_name}</span>
                    </div>
                  {/if}
                {:else}
                  {#if origin.length  > destMaxChars }
                  <div class="flex-grow text-left pr-2 my-auto color-white overflow-hidden">
                      <Marquee pauseOnHover={true} speed={origin.length * 0.3}>
                        <span class="color-white pr-10"><strong>{origin}</strong></span>
                      </Marquee>
                      Chegada a <span class="badge header-bg-arrivals my-2"><strong>{stop_code}</strong>&nbsp;{stop_name}</span>
                  </div>
                  {:else}
                    <div class="flex-grow text-left pr-2 my-auto color-white overflow-hidden">
                      <strong>{origin}</strong>
                      <br>
                      Chegada a <span class="badge header-bg-arrivals my-2"><strong>{stop_code}</strong>&nbsp;{stop_name}</span>
                    </div>
                  {/if}
                {/if}
                <div class="w-80 text-left pr-2 my-auto font-bold color-white flex-shrink-0 flex-grow-0 overflow-hidden">
                  {#if type === 'departures'}
                    {#if destination_municipality.length > 20}
                      <Marquee pauseOnHover={true} speed={destination_municipality.length * 0.3}>
                        {destination_municipality.toUpperCase()}
                      </Marquee>
                    {:else}
                      {destination_municipality.toUpperCase()}
                    {/if}
                  {:else}
                    {#if origin_municipality.length > 20}
                      <Marquee pauseOnHover={true} speed={origin_municipality.length * 0.3}>
                        {origin_municipality.toUpperCase()}
                      </Marquee>
                    {:else}
                      {origin_municipality.toUpperCase()}
                    {/if}
                  {/if}
                </div>
                {#if type === 'departures'}
                  <!-- PARTIDAS -->
                  <div class="w-44 my-auto text-center color-white font-bold flex-shrink-0 flex-grow-0">
                    {#if departureTimeRelativeDelay == 0 || futureDate}
                      <span class="ml-3" use:tooltip={departureDelay}>{departureTimeRelativeClock}</span>
                    {:else}
                      {#if departureTimeRelativeDelay != departureTimeRelative}
                        {#if departureDelay > 0}
                          <div class="inline-flex">
                            <img width="40px" class="bounce-effect" src="../img/svg/bullet-red.svg" alt="Atrasado"/>
                            <span class="ml-3" use:tooltip={arrivalDelay}>{departureTimeRelativeClock}</span>
                          </div>
                        {:else}
                          <div class="inline-flex">
                            <img width="38px" src="../img/svg/bullet-green-info.svg" alt="Atrasado"/>
                            <span class="ml-3" use:tooltip={arrivalDelay}>{departureTimeRelativeClock}</span>
                          </div>
                        {/if}
                      {:else}
                        <span class="ml-3" use:tooltip={departureDelay}>{departureTimeRelativeClock}</span>
                      {/if}
                    {/if}
                  </div>
                  <div class="w-80 p-2 my-auto text-center color-white flex-shrink-0 flex-grow-0">
                    {#if departureTimeRelativeDelay == 0}
                      <div class="inline-flex">
                        {#if !futureDate}
                          {#if departureDelayMs < 0}
                            <img src="../img/svg/arrival.svg" alt="Chegada" width="40px"/>
                            <span class="my-auto info-departure fade-text">PARTIU</span>
                          {:else}
                            <img src="../img/svg/arrival.svg" alt="Chegada" width="40px"/>
                            <span class="my-auto info-departure fade-text">EMBARQUE</span>
                          {/if}
                        {/if}
                      </div>
                    {:else}
                      {#if departureTimeRelativeDelay != departureTimeRelative && departureTimeRelativeDelay != 0 && !futureDate}
                        <div class="inline-flex">
                          <img width="35px" src="../img/svg/departure-time.svg" alt="Atrasado"/>
                          <p class="mt-2px ml-1 color-info-time">NOVA HORA <span class="font-bold-2">{departureTimeRelativeDelayClock}</span></p>
                        </div>
                      {:else}
                        <span></span>
                      {/if}
                    {/if}
                  </div>
                {:else}
                  <!-- CHEGADAS -->
                  <div class="w-44 my-auto text-center color-white font-bold flex-shrink-0 flex-grow-0">
                    {#if arrivalTimeRelativeDelay == 0 || futureDate}
                      <span class="ml-3" use:tooltip={arrivalDelay}>{arrivalTimeRelativeClock}</span>
                    {:else}
                      {#if arrivalTimeRelativeDelay != arrivalTimeRelative}
                        {#if arrivalDelay > 0}
                          <div class="inline-flex">
                            <img width="40px" class="bounce-effect mt-7px" src="../img/svg/bullet-red.svg" alt="Atrasado"/>
                            <span class="ml-3" use:tooltip={arrivalDelay}>{arrivalTimeRelativeClock}</span>
                          </div>
                        {:else}
                          <div class="inline-flex">
                            <img width="38px" src="../img/svg/bullet-green-info.svg" alt="Atrasado"/>
                            <span class="ml-3" use:tooltip={arrivalDelay}>{arrivalTimeRelativeClock}</span>
                          </div>
                        {/if}
                      {:else}
                        <span class="ml-3" use:tooltip={arrivalDelay}>{arrivalTimeRelativeClock}</span>
                      {/if}
                    {/if}
                  </div>
                  <div class="w-80 p-2 my-auto text-center color-white flex-shrink-0 flex-grow-0">
                    {#if arrivalTimeRelativeDelay == 0}
                      <div class="inline-flex">
                        {#if !futureDate}
                          {#if arrivalDelayMs < 0}
                            <img src="../img/svg/arrival.svg" alt="Chegada" width="40px"/>
                            <span class="info-departure fade-text">CHEGOU</span>
                          {:else}
                            <img src="../img/svg/arrival.svg" alt="Chegada" width="40px"/>
                            <span class="info-departure fade-text">A CHEGAR</span>
                          {/if}
                        {/if}
                      </div>
                    {:else}
                      {#if arrivalTimeRelativeDelay != arrivalTimeRelative && arrivalTimeRelativeDelay != 0 && !futureDate}
                        <div class="inline-flex">
                          <img width="35px" src="../img/svg/departure-time.svg" alt="Atrasado"/>
                          <p class="mt-2px ml-1 color-info-time">NOVA HORA <span class="font-bold-2">{arrivalTimeRelativeDelayClock}</span></p>
                        </div>
                      {:else}
                        <span></span>
                      {/if}
                    {/if}
                  </div>
                {/if}
              </div>


            {/if}
            {:else}
              {#if destination != "" || date != "" || time != ""}
                <div class="table-row">
                  <Message title="Sem {request_type_trans} previstas..." text="Não existem {request_type_trans} para os filtros definidos."/>
                </div>


              {:else}
                <div class="table-row">
                  <Message title="Sem {request_type_trans} previstas..." text="Não existem {request_type_trans} para as próximas horas."/>
                </div>
              {/if}
            {/each}

            <!-- -------- Footer -------- -->
            <div class="inline-flex flex-col pagination">
              <div class="absolute left-4 top-1/2 -translate-y-1/2 inline-flex my-auto">
                <img class="logo-footer" alt="Wegoshare" src={'img/wgs_white_green.png'}/><span class="text-footer content-center text-gray-700 dark:text-gray-400">© {currentYear} Wegoshare, Lda.</span>
              </div>
              {#if page_count > 1 && !displayMode}
              <div class="inline-flex my-auto">
                <!-- Buttons -->
                  <button on:click={previousPage} class="flex items-center justify-center px-3 text-xl font-bold text-white transition-opacity" class:opacity-50={currentPage === 1} class:pointer-events-none={currentPage === 1} class:underline={currentPage > 1}>
                    <svg class="w-3.5 h-3.5 me-2 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5H1m0 0 4 4M1 5l4-4"/>
                    </svg>
                    Anterior
                  </button>
                <span class="text-base text-gray-700 dark:text-gray-400 content-center">Página <span class="font-semibold text-gray-900 dark:text-white">{currentPage}</span> de <span class="font-semibold text-gray-900 dark:text-white">{page_count}</span></span>
                  <button on:click={nextPage} class="flex items-center justify-center px-3 text-xl font-bold text-white transition-opacity" class:opacity-50={currentPage === page_count} class:pointer-events-none={currentPage === page_count} class:underline={currentPage < page_count}>
                    Seguinte
                    <svg class="w-3.5 h-3.5 ms-2 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9"/>
                    </svg>
                  </button>
              </div>
              {/if}
              {#if showLogo}
              <div class="absolute right-4 top-1/2 -translate-y-1/2 inline-flex my-auto">
                logo
              </div>
              {/if}
            </div>

          </div>
        </div>
      {:else}
        <div class="mt-32">
          <div class="w-full flex flex-col justify-center items-center text-center">
            <div class="">
              <img width="150px" alt="Bus Gif Loading" src="img/bus-anim.gif">
            </div>
          </div>
          {#if inactive_group}
            <Loading title="Grupo de Paragens Inactivo ou Inexistente" text="O Grupo de Paragens está inactivo ou é inexistente. Contacte o Suporte para mais informações."/>
          {:else}
            <Loading title="A carregar dados de {request_type_trans}..." text="Estamos a obter os dados de {request_type_trans} para as próximas horas."/>
          {/if}
          
        </div>
      {/if}
    {:else}
      <div>
        <div class="flex items-center m-10">
          <img width="220px" alt="Logo Cidade" src="img/logo-GUI.png">
        </div>
        <Message title="Iremos ser breves..." text="Estamos com alguns problemas a mostrar a informação ({groupId})"/>
      </div>
    {/if}
</div>

<!-- Modal -->
{#if isOpen}
  <div class="overlay"></div>
  <div class="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-50">
    <div class="bg-white w-4/5 rounded-3xl shadow-lg p-6 relative flex flex-col border-8 border-black">
      
      <form>
        <!-- Close Button -->
        <button on:click={closeModal} class="absolute top-4 right-4 text-xl text-black"><i class="fa-2xl fa-solid fa-xmark"></i></button>

        <h2 class="text-xl font-bold mt-8 mb-2 modal-text-size">Data/Hora</h2>

        <!-- Date and Time Fields -->
        <div class="flex gap-4">

          <!--<input type="date" bind:value={date} placeholder="Selecione uma data" class="select-departure-board-style-wgs">-->

          <select bind:value={date} class="select-departure-board-style-wgs">
            <option value="" disabled selected>Selecione uma data</option>
            {#each dayOptions as d}
              <option value={d.value}>{d.label}</option>
            {/each}
          </select>

          <select bind:value={time} class="select-departure-board-style-wgs">
            <option value="" disabled selected>Selecione uma hora</option>
            {#each filteredTimeOptions as t}
              <option value={t}>{t}</option>
            {/each}
          </select>
        </div>

        <!-- Destination Dropdown -->
        
        <h2 class="text-xl font-bold mt-8 mb-2 modal-text-size">
          Destino
          {#if typedText != ''}
            <span> - {typedText}</span>
          {/if} 
          ({destinationStopsFiltered.total} {#if destinationStopsFiltered.total == 1}paragem{:else}paragens{/if})
        </h2>

        {#if destinationStopsFiltered.total > 0}
          <select bind:value={destination} class="select-departure-board-style-wgs">
            <option value="" disabled selected>Selecione uma paragem de destino</option>
            {#each destinationStopsFiltered.stops as stop}
              <option value={stop}>{stop.stop_name_to_show} {#if stop.stop_municipality != undefined && stop.stop_municipality != ''}({stop.stop_municipality.toUpperCase()}){/if}</option>
            {/each}
          </select>
        {:else}
          <select class="select-departure-board-style-wgs">
            <option value="" disabled selected>Sem paragens para o texto selecionado</option>
          </select>
        {/if}

        <div class="row">
          <div class="alphabet mt-6 mb-1">
            {#each keyboard[0] as letter}
              <button type="button" class="alphabet-btn" on:click={() => addLetter(letter)}>
                {letter}
              </button>
            {/each}

            <button type="button" class="alphabet-btn backspace" on:click={backspace}>⌫</button>
          </div>
        </div>

        <div class="row">
          <div class="alphabet mt-1 mb-1">
            {#each keyboard[1] as letter}
              <button type="button" class="alphabet-btn" on:click={() => addLetter(letter)}>
                {letter}
              </button>
            {/each}
          </div>
        </div>

        <div class="row">
          <div class="alphabet mt-1 mb-1">
            {#each keyboard[2] as letter}
              <button type="button" class="alphabet-btn" on:click={() => addLetter(letter)}>
                {letter}
              </button>
            {/each}
          </div>
        </div>

        <div class="row">
          <div class="alphabet mt-1 mb-1">
            {#each keyboard[3] as letter}
              <button type="button" class="alphabet-btn" on:click={() => addLetter(letter)}>
                {letter}
              </button>
            {/each}

            <button type="button" class="alphabet-btn clear" on:click={clearText}>Limpar</button>
          </div>
        </div>

        <!-- Buttons -->
        <div class="flex justify-between mt-16">
          <button on:click={clear} class="button-effect-black">Limpar Filtros</button>
          <button on:click={applyFilters} class="button-effect">Aplicar</button>
        </div>
      </form>

    </div>
  </div>
{/if}
